


    <div  fxLayout="row wrap" fxLayoutAlign="space-between center" class="dialog-headline">
        <h2 mat-dialog-title ></h2>
        <button mat-icon-button mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
   
    <br>
    <div class="scrollingDiv" mat-dialog-content>
      
        
        <table class="table table-bordered">
            <colgroup>
                <col width="50%">
                <col width="20%">
                <col width="30%">
            </colgroup>
            <tbody><tr>
                <td rowspan="7" style="text-align: center;">
                    

                <div class="s_imgbox">
                    <ul>
                        <a ><img style="width:250px;height:400px;" src="/assets/image.png" alt=""> </a>
                        <br>
                       
                    </ul>
                </div>

                </td>
                <th class="table-active">{{"Identifiant de la classification"|translate}}</th>
                <td>{{detail.cateId}}</td>
            </tr>
            <tr>
                <th class="table-active">{{"prodId"|translate}}</th>
                <td>{{detail.prodId}}</td>
            </tr>
            <tr>
                <th class="table-active">{{"Nom de la classification"|translate}}</th>
                <td>{{detail.cateNm}}</td>
            </tr>
            <tr>
                <th class="table-active">{{"Nom de la classification en anglais"|translate}}</th>
                <td>{{detail.cateNmEn}}</td>
            </tr>
            <tr>
                <th class="table-active">{{"Unite de mesure"|translate}}</th>
                <td>{{detail.prodUnit}}</td>
            </tr>
            <tr>
                <th class="table-active">{{"Pays d'origine du produit"|translate}}</th>
                <td>{{detail.nacd}}</td>
            </tr>
            <tr>
                <th class="table-active">{{"Date d'enregistrement"|translate}}</th>
                <td>{{detail.regDt| date : 'dd/MM/yyyy '}}</td>
            </tr>
        </tbody></table>


        <table class="table table-bordered">
            <colgroup>
             <col width="20%">
             <col width="30%">
             <col width="20%">
             <col width="30%">
         </colgroup>
         <tbody><tr>
             <th class="table-active">{{"Modèle"|translate}}</th>
             <td>{{detail.prodModel}}</td>
             <th class="table-active">{{"Premiere annee de la fabrication du produit"|translate}}</th>
             <td>{{detail.prodManuYear}}</td>
         </tr>
         <tr>
             <th class="table-active">{{"Nom du fabricant"|translate}}</th>
             <td>{{detail.compNm}}</td>
             <th class="table-active">{{"N° de registre du commerce"|translate}}</th>
             <td></td>
         </tr>
         <tr>
         <th class="table-active">{{"fournisseur responsable de l'enregistrement"|translate}}</th>
             <td>{{detail.instNm}}</td>
         </tr>
         <tr>
             <th class="table-active">{{"Nom du produit"|translate}}</th>
             <td colspan="3">{{detail.prodNm}}</td>
         </tr>

         <tr>
             <th class="table-active">{{"Nom du produit en anglais"|translate}}</th>
             <td colspan="3">{{detail.prodNmEn}}</td>
         </tr>
         <tr>
             <th class="table-active">{{"Description du produit"|translate}}</th>
              <td colspan="3">
                  
                 
                 
                 
                 
                 <textarea name="prodDesc" rows="5" cols="90" readonly="readonly" style="height:80px" class="article_textarea">
                    {{detail.prodDesc}}
                </textarea>
             </td>
         </tr>
         <tr>
             <th class="table-active">{{"Référence fournisseur"|translate}}</th>
             <td>{{detail.gtinCd}} </td>
             <th class="table-active">{{"Marque"|translate}}</th>
             <td> {{detail.prodBrand}} </td>
         </tr>
         <tr>
             <th class="table-active">{{"Type du produit"|translate}}</th>
             <td>
                {{detail.prodSpec}}
             </td>
             <th class="table-active">{{"Mise en ligne O/N"|translate}}</th>
             <td>
                  {{detail.useYn|translate}}
                 
             </td>
         </tr>
         <tr>
             <th class="table-active">{{"Fichiers attachés"|translate}}</th>
             <td colspan="3">
                 

                 
                 
             </td>
         </tr>
     </tbody></table>




     <table  class="table table-bordered">
        <tbody>
            <tr *ngFor="let col of list">
               
                    <th width="40%" class="table-active">
                       
                          
                            {{ col.attrNm | uppercase}}
                       

                      

                    </th>
                    <td>
                        {{ col.attrValue }} {{ col.attrUom }}
                    </td>
                    
                
               
               
            </tr></tbody>
     
       
    </table>
       
        

   
    

    </div>
   
  

